var map = {
	"./backoffice.de.locale.json": "Ccae",
	"./backoffice.el.locale.json": "7nQv",
	"./backoffice.en.locale.json": "2/r1",
	"./backoffice.fr.locale.json": "Pnw9",
	"./base.de.locale.json": "f7Qo",
	"./base.el.locale.json": "EPQ8",
	"./base.en.locale.json": "GPvB",
	"./base.fr.locale.json": "JDIn",
	"./customerAnalytics.de.locale.json": "HkuW",
	"./customerAnalytics.el.locale.json": "cqAx",
	"./customerAnalytics.en.locale.json": "jRA4",
	"./customerAnalytics.fr.locale.json": "Pv+x",
	"./giftSelection.de.locale.json": "0uvs",
	"./giftSelection.el.locale.json": "/4Zj",
	"./giftSelection.en.locale.json": "bFV1",
	"./giftSelection.fr.locale.json": "5PPO",
	"./services.de.locale.json": "7fmn",
	"./services.el.locale.json": "6hEm",
	"./services.en.locale.json": "vvlQ",
	"./services.fr.locale.json": "xoMM"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "WCvE";